import { Injectable } from '@angular/core';
import {
  ItemIconUrl,
  PriceBreakdown,
  PriceBreakdownItem,
  PriceBreakdownPrintAreaNameEnum,
  PriceBreakdownPrintAreaNameType,
} from '@api-ui-app/src/app/shared/price-breakdown/types/price-breakdown';
import { AssetsCollection } from '@gelato-api-ui/core/designs/assets-collection';
import { AssetProviderUid } from '@gelato-api-ui/core/designs/asset-provider-uid.enum';

@Injectable({ providedIn: 'root' })
export class PriceBreakdownService {
  format(data: PriceBreakdown) {
    return Object.keys(data).reduce((acc, key) => {
      const price = data[key] as string;
      return [
        ...acc,
        {
          iconUrl: ItemIconUrl.PrintSide,
          imageUrl: null,
          price,
          name: key as PriceBreakdownPrintAreaNameType,
        },
      ];
    }, [] as PriceBreakdownItem[]);
  }

  formatForBreakdownList(data: PriceBreakdown) {
    const printAreasData = { ...data };
    delete printAreasData[PriceBreakdownPrintAreaNameEnum.Product];
    return this.format(printAreasData);
  }

  getAssetPreview(assetsCollection: AssetsCollection, assetId: string): string {
    return assetsCollection[assetId]?.files.filter(f => f.type === 'preview_thumbnail')[0]?.url || '';
  }

  getAssetProviderId(assetsCollection: AssetsCollection, assetId: string): AssetProviderUid {
    return assetsCollection[assetId]?.assetProviderUid;
  }
}
